import React from "react";
import ContentPage from "./ContentPage";

const PrivacyPolicyPage = () => (
  <ContentPage slug="privacy-policy" category="Legal" />
);

export default PrivacyPolicyPage;
